module.exports = __webpack_public_path__ + "images/home/index/values-assign-bg-0e9e8840bfeda4d1af4df59c8664a5fd.png";